const { VITE_REGIONAL_DOMAINS } = import.meta.env;

const supportedRegionalDomains = VITE_REGIONAL_DOMAINS.split(",");

function getDomainSuffix(currentOrigin: string): string | null {
  try {
    return new URL(currentOrigin).hostname.split(".").slice(-1)[0];
  } catch {
    return null;
  }
}

function isDomainSupported(domain: string): boolean {
  return supportedRegionalDomains.includes(domain);
}

export default function resolveAppUrl(currentUrl: string, destinationUrl: string): string {
  if (currentUrl.includes("localhost")) {
    return destinationUrl;
  }

  const currentDomainSuffix = new URL(currentUrl).hostname.split(".").slice(-1)[0];

  if (supportedRegionalDomains.includes(currentDomainSuffix)) {
    const urlParts = destinationUrl.split(".");
    urlParts[urlParts.length - 1] = currentDomainSuffix;
    return urlParts.join(".");
  } else {
    return destinationUrl;
  }
}

export { getDomainSuffix, isDomainSupported };
